<template>
    <span>
        <a-modal title="GENERAR AMORTIZACIÓN"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar">
          <a-form-model layout="vertical" :model="iAmortizacion" :rules="formRules"
                        @submit="confirmar"
                        @submit.native.prevent ref="formAmortizacion">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colSpan">
                <a-form-model-item :label="$t('Proceso')" prop="prc" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       v-model="iAmortizacion.prc"
                                       endpoint="hierarchy_lookup"
                                       :params="procesos_liquidacion"
                  ></form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-alert type="error" :message="mensajeError" v-if="error"/>
            </a-row>
          </a-form-model>
        </a-modal>
    </span>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_loans'],
    data () {
      return {
        procesos_liquidacion: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        colSpan: {
          xs: 24,
          md: 24
        },
        formRules: {},
        iAmortizacion: {},
        modalVisible: false,
        modalLoading: true,
        error: false
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    methods: {
      initFormRules () {
        this.formRules = {
          prc: [{
            required: true,
            message: 'Valor requerido'
          }]
        }
      },
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar () {
        this.$refs.formAmortizacion.validate(valid => {
          if (valid) {
            this.modalLoading = true
            this.iAmortizacion.id_loans = this.id_loans
            this.httpClient.getInstance().post('loan/load_amortization', this.iAmortizacion)
              .then((response) => {
                Mensajes.success('Correcto', response.data.pv_message)
                this.$emit('ismodalok')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.modalLoading = false
                this.modalVisible = false
                this.iAmortizacion = {}
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/BotonGenerarAmortizacion.vue